import React from "react"
import Showdown from "showdown"
import Prose from "./prose"

const Markdown = ({body}) => {
    const converter = new Showdown.Converter({ strikethrough: true })
    const htmlBody = converter.makeHtml(body)
    return (
        <Prose>
            <div dangerouslySetInnerHTML={{__html: htmlBody}} />
        </Prose>
)}

export default Markdown